module.exports = __webpack_public_path__ + "868d5e6c3677d8830232a6804e53d370.pdf";